/* eslint-disable import/no-webpack-loader-syntax */
import DashboardSvg from "!file-loader!../../assets/svgs/space_dashboard_white_24dp.svg";
import ProductsSvg from "!file-loader!../../assets/svgs/book-svgrepo-com.svg";
import POCSvg from "!file-loader!../../assets/svgs/noun-flask-3136637.svg";
import RecSysSvg from "!file-loader!../../assets/svgs/network-svgrepo-com.svg";
import AdminiSvg from "!file-loader!../../assets/svgs/build-circle.svg";
import StoragedSvg from "!file-loader!../../assets/svgs/storage_white_24dp.svg";

import CalendarSvg from "!file-loader!../../assets/svgs/calendar.svg";
import RehabplanSvg from "!file-loader!../../assets/svgs/rehabplan.svg";
import TelerehabSvg from "!file-loader!../../assets/svgs/telerehab.svg";

import sensorIcon from "../../assets/icons/sensor.png";
import OrgIcon from "../../assets/icons/org.png";
import MarkerIcon from "../../assets/icons/marker.png";
// import CctvIcon from "../../assets/icons/cctv.png"
// import CctvHlIcon from "../../assets/icons/cctv-hl.png"
import CctvIcon from "../../assets/icons/cctv-default.png";
import CctvHlIcon from "../../assets/icons/cctv-low.png";
import TimerIcon from "../../assets/icons/timer.png";
import NecLogo from "!file-loader!../../assets/svgs/nec_logo_4.svg";
import disconnect from "../../assets/disconnect.png";
import Image00006 from "../../assets/image/Image00006.png";
import Setting from "../../assets/icons/setting.png";

export const IconSvg = {
  DashboardSvg,
  ProductsSvg,
  POCSvg,
  RecSysSvg,
  AdminiSvg,
  CalendarSvg,
  RehabplanSvg,
  TelerehabSvg,
  StoragedSvg,
  NecLogo,
  Setting
};

export const MAP_ICONS = {
  "sensor-marker": sensorIcon,
  "icon-org": OrgIcon,
  "icon-marker": MarkerIcon,
  "icon-sensor": CctvIcon,
  "icon-sensor-hl": CctvHlIcon,
  "icon-timer": TimerIcon,
};

export const IMG = {
  disconnect: disconnect,
};

export const MAP_IMG = {
  img1: Image00006,
};
